import { Component } from '@angular/core';
import { Input, Output, OnInit, EventEmitter } from '@angular/core';

/**
 * Component providing a collection of system search fields.
 * See SrsFieldComponent for individual field implementation.
 */
@Component({
	selector: 'collection',
	templateUrl: './collection.component.html',
	styleUrl: './collection.component.css'
})
export class CollectionComponent implements OnInit {
	@Input() fields: any[] = [];
	@Output() triggerUpdateSearch = new EventEmitter<void>();
	
	constructor() { }

	ngOnInit() {
		this.sortFields();
	}

	private sortFields() {
		if (!Array.isArray(this.fields)) {
	        console.error("sortFields Error: fields is not an array", this.fields);
	        return;
        }
		if (this.fields) {
			this.fields.sort((a, b) => (a.level ?? 0) - (b.level ?? 0));
		}
	}
	
	// Bound in the template
	onUpdateSearch(): void {
		this.triggerUpdateSearch.emit();
	}
}
